// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"2fa62ce3","838":"98cf069a","984":"76eb5ab4"}[chunkId] + ".chunk.js";
};